module.exports = __webpack_public_path__ + "media/images/quote-97b465197108a0040e6d9f40310dceb7.svg";